// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__INUUO","btn-hover":"Button_btn-hover__vEIv2"};